import { Avatar } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import MatchPercentageCircularBarComponent from './MatchPercentageCircularBarComponent';
import VerifiedTooltip from '../profile/VerifiedTooltip';
import { stringAvatar } from 'shared-utils';
import { Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import styled from '@emotion/styled';
import { useThemeContext } from 'src/context/ThemeProvider';
import { UserExperienceLevelType } from 'types';

interface Props {
	imgUrl: string;
	name: string;
	company: string;
	role: string;
	yearsOfExperience: UserExperienceLevelType;
	matchPercentage: number;
	isVerified?: boolean;
	primaryTechStack?: string;
}

export const LightTooltip = styled(({ className, ...props }: TooltipProps & { light: boolean }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(props => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: props?.light ? 'white' : '#1F2A37',
		color: props?.light ? '#1C1C28' : '#8b8e94',
		padding: '0px',
		border: props?.light ? '1px solid #E4E4EB' : '0px',
	},
	[`& .${tooltipClasses.arrow}`]: {
		color: props?.light ? 'white' : '#1F2A37',
	},
}));

const RecruiterCandidateCardHeader = ({
	imgUrl,
	isVerified,
	name,
	company,
	role,
	yearsOfExperience,
	matchPercentage,
	primaryTechStack,
}: Props) => {
	const [maxLength, setMaxLength] = useState<number>(15);
	const { themeMode } = useThemeContext();

	const companyString = role && company ? `${role} @ ${company}` : undefined;
	const experienceString =
		yearsOfExperience === UserExperienceLevelType.FINAL_YEAR_STUDENT
			? 'Final Year Student'
			: yearsOfExperience === UserExperienceLevelType.FRESHER
			  ? 'Fresher'
			  : yearsOfExperience === UserExperienceLevelType.OneToTwoYears
			    ? '1-2 years experience'
			    : yearsOfExperience === UserExperienceLevelType.TwoPlusYears
			      ? '2+ years experience'
			      : 'Fresher';
	const subTextCandidate =
		companyString && experienceString ? `${companyString} | ${experienceString}` : companyString ?? experienceString;

	useEffect(() => {
		if (window.innerWidth < 960) {
			setMaxLength(15);
		} else {
			setMaxLength(30);
		}
	}, []);

	return (
		<>
			<div className="flex">
				<div className="flex grow-2 gap-2">
					<Avatar size="md" img={imgUrl} rounded placeholderInitials={stringAvatar(name.trim().toUpperCase() || '')} />

					<div>
						<div className="text-[18px] font-[600] text-[#1C1C28] dark:text-white">
							<div className="flex gap-1">
								{name.length > maxLength ? (
									<>
										<Tooltip title={name} placement="top">
											<span
												onClick={e => {
													e.stopPropagation();
												}}
											>
												{name.substring(0, maxLength)}...
											</span>
										</Tooltip>
									</>
								) : (
									<>{name}</>
								)}
								{isVerified ? (
									<div className="flex flex-col justify-center">
										<LightTooltip
											light={!(themeMode === 'dark')}
											title={<VerifiedTooltip />}
											placement="bottom"
											arrow={false}
										>
											<img src="/assets/verified-tag.svg" alt={'verified-tag'} width={14} height={14} />
										</LightTooltip>
									</div>
								) : null}
							</div>
						</div>

						<div className="text-[12px] font-[500] text-[#28293D] dark:text-[#C7C9D9]">
							{subTextCandidate && subTextCandidate.length > maxLength ? (
								<>
									<Tooltip title={(primaryTechStack ? primaryTechStack + ' | ' : '') + subTextCandidate}>
										<span
											onClick={e => {
												e.stopPropagation();
											}}
										>
											{primaryTechStack ? primaryTechStack + ' | ' : ''}
											{subTextCandidate.substring(0, maxLength)}...
										</span>
									</Tooltip>
								</>
							) : (
								<>
									{primaryTechStack ? primaryTechStack + ' | ' : ''}
									{subTextCandidate}
								</>
							)}
						</div>
					</div>
				</div>
{/* 
				<div className="ml-2">
					{matchPercentage ? (
						<div className="w-[39.692px]">
							<MatchPercentageCircularBarComponent value={matchPercentage} />
						</div>
					) : null}
				</div> */}
			</div>
		</>
	);
};

export default RecruiterCandidateCardHeader;
